import ghAnalytics from '../../../../lib/analytics';

export default (dispatch) => {
  const recordLayersStatus = (layers) => {
    layers.forEach(layer => {
      if (layer.control.enabled) {
        ghAnalytics.logLayerActiveDisabled(
          layer.stateName,
          layer.categoryName,
          layer.subCategoryName,
          layer.layerName
        );
      } else {
        ghAnalytics.logLayerRecentEnabled(
          layer.stateName,
          layer.categoryName,
          layer.subCategoryName,
          layer.layerName
        );
      }
    })
  };

  const setToggledLayers = (layers, status) => {
    const toggledLayers = []
    layers.forEach(layer => {
      const [sn, cn, scn, ln] = layer.split('|');
      toggledLayers.push({
        stateName: sn,
        categoryName: cn,
        subCategoryName: scn,
        layerName: ln,
        control: {
          enabled: status,
        }
      })
    })
    return toggledLayers
  }

  const toggleLayer = (layer) => {
    dispatch({
      type: 'layers/setLayerEnabledStatus',
      payload: {
        categoryName: layer.categoryName,
        layerName: layer.layerName,
        stateName: layer.stateName,
        status: !layer.control.enabled,
        subCategoryName: layer.subCategoryName,
      },
    });
  }
  
  const toggleLayers = (all, layers, status) => {
    const toggledLayers = []
    layers.forEach(layer => {
      toggledLayers.push({
        categoryName: layer.categoryName,
        layerName: layer.layerName,
        stateName: layer.stateName,
        status: status,
        subCategoryName: layer.subCategoryName,
      })
    })
    dispatch({
      type: 'layers/setMultipleLayersEnabledStatus',
      payload: { all, toggledLayers, status }
    });
    // recordLayersStatus(toggledLayers)
  };

  return {
    clearRecentLayers: () => {
      ghAnalytics.logLayerRecentsCleared();
      dispatch({
        type: 'layers/clearRecentLayersData'
      })
    },
    toggleMultipleLayers: (layers, status) => {
      const toggledLayers = setToggledLayers(layers, status)
      toggleLayers(true, toggledLayers, status)
    },
    toggleSingleLayer: (layer) => {
      toggleLayer(layer)
    },
  };
};
